import { Col, Dropdown, Modal, Row, Space, Typography, message } from "antd";
import CompanyUsersView from "../components/CompanyUsersView";
import { useState } from "react";
import { Guid } from "guid-typescript";
import { SearchQuery } from "../code/search-query/search-query";
import { CompanyUser } from "../repository/data.default";
import Loader from "../controls/Loader";
import { getCompanyUsersExport } from "../repository/data.repository";
import CompanyUserView from "../components/CompanyUserView";
import RegisterUsersWizard from "../components/RegisterUsersWizard";
import { getProblemMessage } from "../utils/http";

function CompanyUsersPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [registerIsOpen, setRegisterIsOpen] = useState(false);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [userInputMode, setUserInputMode] = useState<"delete" | "view">(
    "view",
  );
  const [userInputUid, setUserInputUid] = useState<string | null | undefined>(
    undefined,
  );
  const [userInputOpen, setUserInputOpen] = useState(false);

  // Events

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onUserInputOpen(mode: "view" | "delete", values?: CompanyUser): void {
    setUserInputMode(mode);
    setUserInputOpen(true);
    setUserInputUid(values?.uid);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading users export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getCompanyUsersExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  function onRegisterUserOpen(): void {
    setRegisterIsOpen(true);
  }

  function onRegisterUserCancel(): void {
    setRegisterIsOpen(false);
  }

  function onRegisterUserFinish(): void {
    setTriggerView(Guid.create().toString());
  }

  function onUserFinish(): void {
    setUserInputOpen(false);
    setTriggerView(Guid.create().toString());
  }

  function onUserClose(): void {
    setUserInputOpen(false);
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Users
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={onRegisterUserOpen}
          >
            Register Users
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <CompanyUsersView
          trigger={triggerView}
          onSearch={onSearch}
          onAction={(key: string, record: any) =>
            onUserInputOpen(key as any, record)
          }
        />
      </Col>
      <CompanyUserView
        key={`${userInputUid ?? "new"}-${userInputMode}`}
        open={userInputOpen}
        mode={userInputMode}
        uid={userInputUid!}
        onFinish={onUserFinish}
        onClose={onUserClose}
      />
      <RegisterUsersWizard
        open={registerIsOpen}
        onFinish={onRegisterUserFinish}
        onCancel={onRegisterUserCancel}
      />
      {contextHolder}
    </Col>
  );
}

export default CompanyUsersPage;
